import api from '@/utils/http/axios'
import { NO_PREFIX_URL } from '@/utils/http/base-url'
export default {
  /**
  * 获取图形验证码
  * @param {string} type USER_LOGIN RESET_PWD
  * @param {string} captchaId
  */
  getGraphicsCode (params = {}, config = {}) {
    return api.post('/api/user/captcha', params, config, 'URLEncoded')
  },
  /**
  * 获取短信验证码
  * @param {string} cstId 客户号
  * @param {string} userId 用户号
  * @param {string} captcha 输入的图形验证码
  * @param {string} captchaId 图形验证码id
  * @param {string} type USER_LOGIN RESET_PWD
  */
  getSmsCode (params = {}, config = {}) {
    return api.post('/api/user/code/sms', params, config, 'URLEncoded')
  },
  /**
  * 获取语音验证码
  * @param {string} cstId 客户号
  * @param {string} userId 用户号
  * @param {string} captcha 输入的图形验证码
  * @param {string} captchaId 图形验证码id
  * @param {string} type USER_LOGIN RESET_PWD
  */
  getVoiceCode (params = {}, config = {}) {
    return api.post('/api/user/code/voice', params, config, 'URLEncoded')
  },
  /**
  * 验证短信验证码
  * @param {string} cstId 客户号
  * @param {string} userId 用户号
  * @param {string} code 输入的短信验证码
  * @param {string} type USER_LOGIN RESET_PWD
  */
  checkSmsCode (params = {}, config = {}) {
    return api.post('/api/user/check', params, config, 'URLEncoded')
  },
  /**
  * 获取客户年费缴存信息及证书到期情况-果仁宝需求
  * @param {string} cstId 客户号
  * @param {string} userId 用户号
  * @param {string} currentBusinessCode '00000000'
  * @param {string} channel '1103'
  */
  checkCert (params = {}, config = {}) {
    return api.post(`${NO_PREFIX_URL}/getannualFee.do`, params, config, 'URLEncoded')
  },
  /**
  * 登录-验证码方式
  * @param {string} cstId 客户号
  * @param {string} userId 用户号
  * @param {string} captcha 图形验证码
  * @param {string} captchaId 图形验证码id
  * @param {string} code 短信验证码
  * @param {string} signData 验签数据
  * @param {string} currentBusinessCode '00000000'
  * @param {string} transferName '登录'
  */
  loginByVerifyCode (params = {}, config = {}) {
    return api.post('/api/login/bycode', params, config, 'URLEncoded')
  },
  /**
  * 获取密码加密因子
  * @param {string} channel '1103'
  * @param {string} responseFormat 'JSON'
  */
  getSrandNum (params = {}, config = {}) {
    return api.get(`${NO_PREFIX_URL}/SrandNum`, params, config)
  },
  /**
  * 验证密码
  * @param {string} cstId 客户号
  * @param {string} userId 用户号
  * @param {string} captchaId 图形验证码id
  * @param {string} captcha 图形验证码
  * @param {string} password 密码
  * @param {string} sranNum 密码因子
  * @param {string} code 输入的短信验证码
  */
  checkPassword (params = {}, config = {}) {
    return api.post('/api/user/passwordCheck', params, config, 'URLEncoded')
  },
  /**
  * 登录-密码方式
  * @param {string} cstId 客户号
  * @param {string} userId 用户号
  * @param {string} captcha 图形验证码
  * @param {string} captchaId 图形验证码id
  * @param {string} password 密码
  * @param {string} signData 验签数据
  * @param {string} sranNum 密码因子
  * @param {string} transferName '登录'
  */
  loginByPassword (params = {}, config = {}) {
    return api.post('/api/login/passwordLogin', params, config, 'URLEncoded')
  },
  /**
  * 首次登录-设置密码
  * @param {string} password 密码
  * @param {string} confirmPassword 确认密码
  * @param {string} sranNum 加密私钥uuid
  */
  setPassword (params = {}, config = {}) {
    return api.post('/api/user/password/set', params, config, 'URLEncoded')
  },
  /**
  * 忘记密码-申请重置密码
  * @param {string} cstId 客户号
  * @param {string} userId 用户号
  * @param {string} signData 加密数据
  * @param {string} transferName 交易名字
  */
  resetPasswordApply (params = {}, config = {}) {
    return api.post('/api/login/pwdResetApply', params, config, 'URLEncoded')
  },
  /**
  * 忘记密码-获取人脸活体验证token
  * @param {string} cstId 客户号
  * @param {string} userId 用户号
  * @param {string} idCardNo 身份证号
  * @param {string} captchaId 图形验证码id
  * @param {string} captcha 图形验证码
  * @param {string} code 短信验证码
  */
  getTokenOfFaceId (params = {}, config = {}) {
    return api.post('/api/faceId/getToken', params, config, 'URLEncoded')
  },
  /**
  * 忘记密码-获取人脸活体验证结果
  * @param {string} cstId 客户号
  * @param {string} userId 用户号
  * @param {boolean} needToken 是否需要token 设置为true
  */
  getResultOfFaceId (params = {}, config = {}) {
    return api.post('/api/faceId/faceResult', params, config, 'URLEncoded')
  },
  /**
  * 忘记密码-重置密码
  * @param {string} cstId 客户号
  * @param {string} userId 用户号
  * @param {string} sranNum 加密私钥uuid
  * @param {string} password 密码
  * @param {string} faceSession face++返回的session
  * @param {string} signData 加密数据
  * @param {string} transferName 交易名字
  */
  resetPassword (params = {}, config = {}) {
    return api.post('/api/login/pwdReset', params, config, 'URLEncoded')
  },
  /**
  * 退出登录
  * @param {string} customerId 客户号
  * @param {string} userId 用户号
  * @param {string} currentBusinessCode '00000001'
  */
  loginOut (params = {}, config = {}) {
    return api.post(`${NO_PREFIX_URL}/userSignOff.do`, params, config, 'URLEncoded')
  }
}
